export const AUDIENCES = [
  { id: "EVENT ORGANIZERS", label: "FOR EVENT ORGANIZERS", bgColor: "bg-[#a4c7cb]" },
  { id: "AGENCIES", label: "FOR AGENCIES", bgColor: "bg-[#008393]" },
  { id: "BRANDS", label: "FOR BRANDS", bgColor: "bg-[#1b2640]" },
];
